import useScreenSize from "@/hooks/useScreenSize";
import { motion } from "framer-motion";

const variants = {
  "fade-up": {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
  },
  "fade-left": {
    initial: { opacity: 0, x: -30 },
    animate: { opacity: 1, x: 0 },
  },
  "fade-right": {
    initial: { opacity: 0, x: 30 },
    animate: { opacity: 1, x: 0 },
  },
  "zoom-in": {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
  },
};

const AnimatedBox = ({
  children,
  type = "fade-up",
  duration = 0.9,
  delay = 0,
  className,
}) => {
  const { width } = useScreenSize();
  const isDesktop = width >= 768;
  const animation = isDesktop ? variants[type] : variants["fade-up"];

  return (
    <motion.div
      className={className}
      initial={animation.initial}
      whileInView={animation.animate}
      transition={{ duration, delay: isDesktop ? delay : 0, ease: "easeInOut" }}
      viewport={{ once: true, amount: 0.1 }}
    >
      {children}
    </motion.div>
  );
};
export default AnimatedBox;
